module.exports = __webpack_public_path__ + "img/16m.1dcad100.jpg";